"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
exports.default = (function (virtual) { return function (data) {
    var fields = virtual.protocol.fields;
    var cmds = virtual.protocol.cmds;
    var cmdId = data.cmdId === undefined ? utils_1.find(Object.keys(cmds), function (key) { return cmds[key].cmdTag === data.cmdTag; }) : data.cmdId;
    var cmd = cmdId === undefined ? undefined : cmds[cmdId];
    if (!cmd) {
        return data;
    }
    var frame = [0x48, 6, 1, (data.msgId || 0) % 0x100, cmd.cmdId].map(function (val) { return utils_1.decToHex(val); });
    cmd.fields.forEach(function (field) {
        var _a = fields[field], dataLength = _a.dataLength, dataType = _a.dataType;
        frame[1] = utils_1.decToHex(utils_1.hexToDec(frame[1]) + dataLength);
        if (dataType === 'NUMBER') {
            var dec = typeof data[field] === 'number'
                ? utils_1.getCorrectVal(data[field], fields[field])
                : utils_1.getValFromProtocol(fields[field]);
            frame.push.apply(frame, utils_1.splitByLength(utils_1.decToHex(dec, dataLength)));
        }
        else if (dataType === 'STRING') {
            var value = data[field] !== null && data[field] !== undefined ? data[field] : '';
            var hex = utils_1.rawToUTF8Bytes(value).map(function (val) { return utils_1.decToHex(val); });
            var raw = hex.concat(utils_1.creatArrayAndFill(dataLength - hex.length, '00')).slice(-dataLength);
            frame.push.apply(frame, raw);
        }
    });
    var checkCode = frame.reduce(function (val, b) { return val + utils_1.hexToDec(b); }, 0);
    frame.push(utils_1.decToHex(checkCode).slice(-2));
    return {
        raw: frame.join('')
    };
}; });



// WEBPACK FOOTER //
// ./src/encode/jsonTransparent.ts